import { Controller } from "@hotwired/stimulus"
import { app } from "theme/stimulus"

app.register(
  "in-view",
  class extends Controller {
    static values = {
      threshold: { type: Number, default: 0 },
      rootMargin: { type: String, default: "0px" },
    }

    connect() {
      const hasHeaderColor = this.element.dataset.headerTextColor
      const rootMargin = hasHeaderColor ? "0px 0px -90% 0px" : this.rootMarginValue

      this.observer = new IntersectionObserver((entries) => this.handleIntersection(entries), {
        threshold: this.thresholdValue,
        rootMargin: rootMargin,
      })

      this.observer.observe(this.element)

      if (hasHeaderColor) {
        setTimeout(() => {
          const rect = this.element.getBoundingClientRect()
          const detectionZoneBottom = window.innerHeight * 0.1
          if (rect.top < detectionZoneBottom && rect.bottom > 0) {
            this.handleIntersection([{ isIntersecting: true }])
          }
        }, 50)
      }
    }

    disconnect() {
      if (this.observer) this.observer.disconnect()
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        const sectionType = this.element.dataset.sectionType
        const elementType = this.element.dataset.elementType
        const hidesHeaderButton = this.element.dataset.hidesHeaderButton === "true"
        const hasButtons = this.element.dataset.hasButtons === "true"
        const headerTextColor = this.element.dataset.headerTextColor

        const eventName = entry.isIntersecting ? "element:entered" : "element:exited"
        const event = new CustomEvent(eventName, {
          detail: {
            sectionType,
            elementType,
            elementId: this.element.id,
            hidesHeaderButton,
            hasButtons,
            headerTextColor,
            intersectionRatio: entry.intersectionRatio,
          },
          bubbles: true,
        })

        this.element.dispatchEvent(event)
      })
    }
  },
)
